import * as React from 'react';

import {Routing} from 'nutshell-core/routing';

import {useNutshellTour} from './use-nutshell-tour';

/**
 * A hook to watch for specific filter values and progress the current tour when
 * they are set.
 */
export function useFilterUrlWatcher(urlParams: string, filterName: string, expectedValue: string) {
    const tourProgressed = React.useRef<boolean>(false);
    const {progressTour} = useNutshellTour();

    React.useEffect(() => {
        if (tourProgressed.current) {
            return;
        }

        const urlParamsObj = Routing.deparam(urlParams);
        const filterValue = urlParamsObj && urlParamsObj.filter && urlParamsObj.filter[filterName];
        if (filterValue === expectedValue) {
            progressTour();
            tourProgressed.current = true;
        }
    }, [filterName, expectedValue, progressTour, urlParams]);
}
